const PartnershipIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="carbon:partnership">
        <path
          id="Vector"
          d="M6 6.75C5.40666 6.75 4.82664 6.57405 4.33329 6.24441C3.83994 5.91477 3.45542 5.44623 3.22836 4.89805C3.0013 4.34987 2.94189 3.74667 3.05764 3.16473C3.1734 2.58279 3.45912 2.04824 3.87868 1.62868C4.29824 1.20912 4.83279 0.923401 5.41473 0.807646C5.99667 0.69189 6.59987 0.7513 7.14805 0.978363C7.69623 1.20543 8.16476 1.58994 8.49441 2.08329C8.82405 2.57664 9 3.15666 9 3.75C9 4.54565 8.68393 5.30871 8.12132 5.87132C7.55871 6.43393 6.79565 6.75 6 6.75ZM18 6.75C17.4067 6.75 16.8266 6.57405 16.3333 6.24441C15.8399 5.91477 15.4554 5.44623 15.2284 4.89805C15.0013 4.34987 14.9419 3.74667 15.0576 3.16473C15.1734 2.58279 15.4591 2.04824 15.8787 1.62868C16.2982 1.20912 16.8328 0.923401 17.4147 0.807646C17.9967 0.69189 18.5999 0.7513 19.1481 0.978363C19.6962 1.20543 20.1648 1.58994 20.4944 2.08329C20.8241 2.57664 21 3.15666 21 3.75C21 4.54565 20.6839 5.30871 20.1213 5.87132C19.5587 6.43393 18.7957 6.75 18 6.75ZM19.5 22.5H16.5C16.1022 22.5 15.7206 22.342 15.4393 22.0607C15.158 21.7794 15 21.3978 15 21V15.75H16.5V21H19.5V14.25H21V9.75C21 9.55109 20.921 9.36032 20.7803 9.21967C20.6397 9.07902 20.4489 9 20.25 9H15.435L12 15L8.565 9H3.75C3.55109 9 3.36032 9.07902 3.21967 9.21967C3.07902 9.36032 3 9.55109 3 9.75V14.25H4.5V21H7.5V15.75H9V21C9 21.3978 8.84196 21.7794 8.56066 22.0607C8.27936 22.342 7.89782 22.5 7.5 22.5H4.5C4.10218 22.5 3.72064 22.342 3.43934 22.0607C3.15804 21.7794 3 21.3978 3 21V15.75C2.60218 15.75 2.22064 15.592 1.93934 15.3107C1.65804 15.0294 1.5 14.6478 1.5 14.25V9.75C1.5 9.15326 1.73705 8.58097 2.15901 8.15901C2.58097 7.73705 3.15326 7.5 3.75 7.5H9.435L12 12L14.565 7.5H20.25C20.8467 7.5 21.419 7.73705 21.841 8.15901C22.2629 8.58097 22.5 9.15326 22.5 9.75V14.25C22.5 14.6478 22.342 15.0294 22.0607 15.3107C21.7794 15.592 21.3978 15.75 21 15.75V21C21 21.3978 20.842 21.7794 20.5607 22.0607C20.2794 22.342 19.8978 22.5 19.5 22.5Z"
          fill="url(#paint0_linear)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="12"
          y1="0.75"
          x2="12"
          y2="22.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="black" />
          <stop offset="1" stopColor="#666666" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PartnershipIcon;
